export default __webpack_public_path__ + "static/media/undraw_contact_us.f6147ad4.svg";